export const registerKey = record => record.lessonId || record.id;
export const matchesRegisterRead = (record, query) => {
  if (query.lessonId) return registerKey(record) === query.lessonId;
  const {date} = record.lessonDetails || {};
  return date && date >= query.fromDate && date <= query.toDate;
};

